/*
 * @Author: DQL
 * @Date: 2020-03-18 09:56:04
 * @LastEditors: DQL
 * @LastEditTime: 2022-09-22 23:44:53
 * @Description: file content
 */

import axios from 'axios';
import config from '@/config';

const commontCtx = config.commontCtx;

export const deptService = {
  // 获取
  get: (deptCode) => { return axios.get(`${commontCtx}/dept/v2/${deptCode}`); },

  // 修改
  update: (params) => { return axios.put(`${commontCtx}/dept/update`, params); },

  // 获取机构扩展字段
  attrDept: () => { return axios.get(`${commontCtx}/attr/dept`); }

};
